<div class="tlr-breakdown-report-container">
    <div *ngIf="!isLoading">
        <div *ngIf="!isDetailsBlock">
            <div class="tlr-breakdown-report-header report-header">
                <p class="section-title">
                    Inspected/Installed Report Results</p>
                <div class="exportToExcel excel-btn">
                </div>
            </div>

            <div class="content-block">
                <div class="div1-1">
                    <div class="">
                        <div class="tlr-breakdown-report-table">
                            <p-table [value]="inspectedInstallReportData" [paginator]="true" [rows]="10"
                                responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Section</th>
                                        <th>Installed</th>
                                        <th>Inspected</th>
                                        <th>Beyond Due Date</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-detail>
                                    <tr>
                                        <td>{{ detail.Section_Name }}</td>
                                        <td align="center">
                                            <a *ngIf="detail.Installed > 0" class="Clickable"
                                                (click)="getDetails(detail, 'I','Installed')">{{detail.Installed}}</a>
                                            <span *ngIf="detail.Installed == 0">{{detail.Installed}}</span>
                                        </td>

                                        <td align="center">
                                            <a *ngIf="detail.Inspected > 0" class="Clickable"
                                                (click)="getDetails(detail, 'N','Inspected')">{{detail.Inspected}}</a>
                                            <span *ngIf="detail.Inspected == 0">{{detail.Inspected}}</span>
                                        </td>
                                        <td align="center">
                                            <a *ngIf="detail.Beyond_Due_Date > 0" class="Clickable"
                                                (click)="getDetails(detail, 'B','Beyond Due Date')">{{detail.Beyond_Due_Date}}</a>
                                            <span *ngIf="detail.Beyond_Due_Date == 0">{{detail.Beyond_Due_Date}}</span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
                <div class="div1-2">
                    <div class="chart-block">
                        <h3 class="chart-title">Inspected/Installed Report - {{currentDate | date:'M/d/yyyy'}}</h3>
                        <p-chart type="bar" [data]="chartData" [options]="chartOptions" [plugins]="plugins"
                            class="chart" (onDataSelect)="selectData($event)"></p-chart>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-details-block" *ngIf="isDetailsBlock">
            <div class="report-header">
                <div>
                    <div class="section-title">Inspected/Installed Report Details </div>
                    <div class="section-sub-title">
                        <span class="text-bold">{{sectionType}}</span>
                        &nbsp;
                        <span class="text-bold">Section:&nbsp; {{sectionTitle}}</span>
                    </div>
                </div>
                <div class="search-criteria">
                    <p-button styleClass="p-button-secondary" (click)="exportToExcel()"> Export to Excel</p-button>
                </div>
            </div>

            <div class="section-wrapper">
                <p-table [value]="inspectedInstallReportData" [paginator]="true" [rows]="10" responsiveLayout="scroll"
                    width="50%">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Tag Number</th>
                            <th>Data Entry Date</th>
                            <th>Op. User ID</th>
                            <th>Division</th>
                            <th>Section</th>
                            <th>Plant</th>
                            <th>LDAR</th>
                            <th>Op. PSI</th>
                            <th>Op. Temp</th>
                            <th>ShutdownDescription</th>
                            <th>Service</th>
                            <th>Insp User ID</th>
                            <th>Service Class</th>
                            <th>OA User ID</th>
                            <th>Permanent Repair Date</th>
                            <th>Eng. User ID</th>
                            <th>TLR Type</th>
                            <th>Maximo WO Number</th>
                            <th>Maximo Outage-T/A</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                <a class="Clickable"
                                    routerLink="/details-section/{{item.Tag_Number}}">{{item.Tag_Number}}</a>
                            </td>
                            <td>{{item.Data_Entry_Date | date : 'MM/dd/YYYY'}}</td>
                            <td>{{item.Operator_CAI}}</td>
                            <td class="left-align">{{item.Division}}</td>
                            <td class="left-align">{{item.Section}}</td>
                            <td class="left-align">{{item.Plant}}</td>
                            <td class="left-align">{{item.LDAR}}</td>
                            <td>{{item.Oper_PSI}}</td>
                            <td>{{item.Oper_Temp}}</td>
                            <td class="left-align">{{item.ShutdownDescription}}</td>
                            <td>{{item.Service}}</td>
                            <td>{{item.InspectionCAI}}</td>
                            <td>{{item.ServiceClass}}</td>
                            <td>{{item.OACAI}}</td>
                            <td [ngClass]="getDateClass(item.Permanent_Repair_Date)">{{item.Permanent_Repair_Date | date
                                :
                                'MM/dd/YYYY'}}</td>
                            <td>{{item.EngineeringCAI}}</td>
                            <td>{{item.TLRType}}</td>
                            <td>{{item.Maximo_WO_Number}}</td>
                            <td>{{item.Maximo_Outage_T_A}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr class="total-sections-row">

                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>

</div>